/**
 * Mapping semantic version to encoded version number, header 4-bit.
 * It's a bit silly to limit the version number to 4-bit, if they keep
 * increasing the version number, the latest possible mapped value is 16
 */
export const Version = {
    /**
     * Created this document from original by square specifications.
     *
     * **Released Date:** 2013-02-22
     */
    "1.0.0": 0x00,
    /**
     * Added fields for beneficiary name and address
     *
     * **Released Date:** 2015-06-24
     */
    "1.1.0": 0x01,
};
/**
 * Kalendárny mesiac.
 *
 * @dprint-ignore
 */
export const Month = {
    January: 0b00000000000001,
    February: 0b00000000000010,
    March: 0b00000000000100,
    April: 0b00000000001000,
    May: 0b00000000010000,
    June: 0b00000000100000,
    July: 0b00000001000000,
    August: 0b00000010000000,
    September: 0b00000100000000,
    October: 0b00001000000000,
    November: 0b00010000000000,
    December: 0b00100000000000,
};
/**
 * Deň platby vyplývajúci z opakovania (Periodicity). Deň v mesiaci je číslo
 * medzi 1 a 31. Deň v týždni je číslo medzi 1 a 7 (1 = pondelok, 2=utorok, …, 7
 * = nedeľa).
 *
 * @dprint-ignore
 */
export const Periodicity = {
    Daily: "d",
    Weekly: "w",
    Biweekly: "b",
    Monthly: "m",
    Bimonthly: "B",
    Quarterly: "q",
    Semiannually: "s",
    Annually: "a",
};
/**
 * Možnosti platby sa dajú kombinovať. Oddeľujú sa medzerou a treba uviesť vždy
 * aspoň jednu z možností:
 *
 * - `PaymentOrder`: platobný príkaz
 * - `StandingOrder`: trvalý príkaz, údaje sa vyplnia do StandingOrderExt
 * - `DirectDebit`: inkaso, údaje sa vyplnia do DirectDebitExt
 */
export const PaymentOptions = {
    /**
     * Platobný príkaz
     */
    PaymentOrder: 0b00000001,
    /**
     * Trvalý príkaz, údaje sa vyplnia do StandingOrderExt
     */
    StandingOrder: 0b00000010,
    /**
     * Inkaso, údaje sa vyplnia do DirectDebitExt
     */
    DirectDebit: 0b00000100,
};
/**
 * Inksaná schéma. Uvádza ja jedna z možností:
 *
 * - SEPA - Inkaso zodpovedá schéme
 * - SEPA. other - iné
 */
export const DirectDebitScheme = {
    /**
     * other - iné
     */
    Other: 0x00,
    /**
     * SEPA - Inkaso zodpovedá schéme
     */
    Sepa: 0x01,
};
/**
 * Typ inkasa. Uvádza ja jedna z možností:
 *
 * @maximum 1
 *
 * - one-off - jednorázové inkaso
 * - recurrent - opakované inkaso
 */
export const DirectDebitType = {
    /**
     * Jednorázové inkaso
     */
    OneOff: 0x00,
    /**
     * Opakované inkaso
     */
    Recurrent: 0x01,
};
/**
 * [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217)
 */
export const CurrencyCode = {
    AED: "AED",
    AFN: "AFN",
    ALL: "ALL",
    AMD: "AMD",
    ANG: "ANG",
    AOA: "AOA",
    ARS: "ARS",
    AUD: "AUD",
    AWG: "AWG",
    AZN: "AZN",
    BAM: "BAM",
    BBD: "BBD",
    BDT: "BDT",
    BGN: "BGN",
    BHD: "BHD",
    BIF: "BIF",
    BMD: "BMD",
    BND: "BND",
    BOB: "BOB",
    BRL: "BRL",
    BSD: "BSD",
    BTN: "BTN",
    BWP: "BWP",
    BYN: "BYN",
    BZD: "BZD",
    CAD: "CAD",
    CDF: "CDF",
    CHF: "CHF",
    CLP: "CLP",
    CNY: "CNY",
    COP: "COP",
    CRC: "CRC",
    CUC: "CUC",
    CUP: "CUP",
    CVE: "CVE",
    CZK: "CZK",
    DJF: "DJF",
    DKK: "DKK",
    DOP: "DOP",
    DZD: "DZD",
    EGP: "EGP",
    ERN: "ERN",
    ETB: "ETB",
    EUR: "EUR",
    FJD: "FJD",
    FKP: "FKP",
    GBP: "GBP",
    GEL: "GEL",
    GHS: "GHS",
    GIP: "GIP",
    GMD: "GMD",
    GNF: "GNF",
    GTQ: "GTQ",
    GYD: "GYD",
    HKD: "HKD",
    HNL: "HNL",
    HRK: "HRK",
    HTG: "HTG",
    HUF: "HUF",
    IDR: "IDR",
    ILS: "ILS",
    INR: "INR",
    IQD: "IQD",
    IRR: "IRR",
    ISK: "ISK",
    JMD: "JMD",
    JOD: "JOD",
    JPY: "JPY",
    KES: "KES",
    KGS: "KGS",
    KHR: "KHR",
    KMF: "KMF",
    KPW: "KPW",
    KRW: "KRW",
    KWD: "KWD",
    KYD: "KYD",
    KZT: "KZT",
    LAK: "LAK",
    LBP: "LBP",
    LKR: "LKR",
    LRD: "LRD",
    LSL: "LSL",
    LYD: "LYD",
    MAD: "MAD",
    MDL: "MDL",
    MGA: "MGA",
    MKD: "MKD",
    MMK: "MMK",
    MNT: "MNT",
    MOP: "MOP",
    MRU: "MRU",
    MUR: "MUR",
    MVR: "MVR",
    MWK: "MWK",
    MXN: "MXN",
    MYR: "MYR",
    MZN: "MZN",
    NAD: "NAD",
    NGN: "NGN",
    NIO: "NIO",
    NOK: "NOK",
    NPR: "NPR",
    NZD: "NZD",
    OMR: "OMR",
    PAB: "PAB",
    PEN: "PEN",
    PGK: "PGK",
    PHP: "PHP",
    PKR: "PKR",
    PLN: "PLN",
    PYG: "PYG",
    QAR: "QAR",
    RON: "RON",
    RSD: "RSD",
    RUB: "RUB",
    RWF: "RWF",
    SAR: "SAR",
    SBD: "SBD",
    SCR: "SCR",
    SDG: "SDG",
    SEK: "SEK",
    SGD: "SGD",
    SHP: "SHP",
    SLL: "SLL",
    SOS: "SOS",
    SRD: "SRD",
    SSP: "SSP",
    STN: "STN",
    SVC: "SVC",
    SYP: "SYP",
    SZL: "SZL",
    THB: "THB",
    TJS: "TJS",
    TMT: "TMT",
    TND: "TND",
    TOP: "TOP",
    TRY: "TRY",
    TTD: "TTD",
    TWD: "TWD",
    TZS: "TZS",
    UAH: "UAH",
    UGX: "UGX",
    USD: "USD",
    UYU: "UYU",
    UZS: "UZS",
    VES: "VES",
    VND: "VND",
    VUV: "VUV",
    WST: "WST",
    XAF: "XAF",
    XCD: "XCD",
    XOF: "XOF",
    XPF: "XPF",
    YER: "YER",
    ZAR: "ZAR",
    ZMW: "ZMW",
    ZWL: "ZWL",
};
